const activeMenu = '/systemSetting'
export default [
  {
    path: activeMenu,
    name: 'systemSetting',
    alwaysShow: true,
    //redirect: '/dashboard',
    component: () => import(/* webpackChunkName: 'nested' */ '@/layout/Layout'),
    meta: {
      order: 700,
      title: 'resource.system.systemsetting',
      icon: 'el-icon-s-tools'
    },
    //システム設定
    children: [
      //ユーザ設定
      {
        path: 'UserManage',
        component: () => import('@/views/system/userManage'),
        name: 'UserManage',
        hidden: false,
        alwaysShow: false,
        meta: {
          order: 701,
          activeMenu: activeMenu,
          icon: 'el-icon-user-solid',
          //角色：管理者
          permission: ['system'],
          title: 'resource.system.userManage',
        }
      },
 /*
      //ロール設定
      {
        path: 'RoleManage',
        component: () => import('@/views/system/roleManage'),
        name: 'RoleManage',
        hidden: false,
        alwaysShow: false,
        meta: {
          order: 702,
          icon: 'el-icon-s-custom',
          //角色：管理者
          permission: ['admin'],
          title: 'resource.system.roleManage',
        }
      },
*/
      //書類設定
      {
        path: 'documentSet',
        component: () => import('@/views/system/documentSet'),
        name: 'documentSet',
        hidden: false,
        alwaysShow: false,
        meta: {
          order: 703,
          activeMenu: activeMenu,
          icon: 'el-icon-setting',
          //角色：管理者
          permission: ['system'],
          title: 'resource.system.documentSet',
        }
      },
      // //レート設定
      // {
      //   path: 'exchangeRateSet',
      //   component: () => import('@/views/system/exchangeRateSet'),
      //   name: 'exchangeRateSet',
      //   hidden: false,
      //   alwaysShow: false,
      //   meta: {
      //     order: 704,
      //     activeMenu: activeMenu,
      //     icon: 'el-icon-setting',
      //     //角色：管理者
      //     permission: ['system'],
      //     title: 'resource.system.exchangeRateSet',
      //   }
      // },
      //共通設定
      {
        path: 'commonSet',
        component: () => import('@/views/system/commonSet'),
        name: 'commonSet',
        hidden: false,
        alwaysShow: false,
        meta: {
          order: 705,
          activeMenu: activeMenu,
          icon: 'el-icon-setting',
          //角色：管理者
          permission: ['system'],
          title: 'resource.MENU.COMMON_SET_VIEW',
        }
      },
    ]
  }
]
